Searches SEEK's library of application screening questions.

A maximum of 10 application questions can be returned.

This query accepts browser tokens that include the `query:application-library-question-suggestions` or `query:enhanced-job-posting` scope.
